import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
} from "@mui/material";
import { Trans, useTranslation } from "react-i18next";

const IdleTimeoutDialog = ({ open, countdown, onStay, onLogout }) => {
  const { t } = useTranslation("account");
  const minutes = Math.floor(countdown / 60);
  const seconds = countdown % 60;
  const timeDisplay = minutes > 0
    ? `${minutes}:${String(seconds).padStart(2, "0")}`
    : `${seconds}s`;

  return (
    <Dialog open={open} maxWidth="xs" disableEscapeKeyDown>
      <DialogTitle>{t("idle.title")}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary">
          <Trans
            ns="account"
            i18nKey="idle.body"
            values={{ time: timeDisplay }}
            components={{
              1: (
                <Typography
                  component="span"
                  variant="body2"
                  fontWeight={600}
                  color="text.primary"
                />
              ),
            }}
          />
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 2, pb: 2 }}>
        <Button onClick={onLogout} color="inherit" size="small">
          {t("common.signOut")}
        </Button>
        <Button onClick={onStay} variant="contained" size="small" autoFocus>
          {t("idle.stay")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default IdleTimeoutDialog;
